import { useCallback, useMemo, useSyncExternalStore } from 'react';
import { BREAKPOINTS, media } from 'styles/themes/constants';

const MOBILE_QUERY = `(max-width: ${BREAKPOINTS.md - 0.02}px)`;

const getServerSnapshot = (): boolean => false;

export const useMediaQuery = (query: string): boolean => {
  const mediaQuery = useMemo(() => {
    if (
      typeof window === 'undefined' ||
      typeof window.matchMedia !== 'function'
    ) {
      return null;
    }

    return window.matchMedia(query);
  }, [query]);

  const subscribe = useCallback(
    (onStoreChange: () => void): (() => void) => {
      if (!mediaQuery) {
        return () => undefined;
      }

      mediaQuery.addEventListener('change', onStoreChange);

      return () => {
        mediaQuery.removeEventListener('change', onStoreChange);
      };
    },
    [mediaQuery]
  );

  const getSnapshot = useCallback(
    (): boolean => mediaQuery?.matches ?? false,
    [mediaQuery]
  );

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};

export const useIsMobile = (): boolean => useMediaQuery(MOBILE_QUERY);

export const useIsTabletUp = (): boolean => useMediaQuery(media.md);

export const useIsDesktop = (): boolean => useMediaQuery(media.xl);
